import styled from 'styled-components'
import { Button } from 'common-components'
import { COLORS } from 'consts/colors'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'
import { premiumButtonStyles } from 'containers/SubSidebar/styled'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: clamp(350px, 60vw, 500px);
  max-width: 90%;
  gap: 24px;
  margin: auto;
  padding: 8px 4px;
`

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-top: 24px;
`

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;

  @media (max-width: ${MOBILE_SIZE_BREAKPOINT - 1}px) {
    flex-direction: column;
    align-items: stretch;
  }
`

export const ActionButton = styled(Button)`
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  @media (max-width: ${MOBILE_SIZE_BREAKPOINT - 1}px) {
    width: 100%;
  }
`

export const WaitButton = styled(ActionButton)`
  flex: 1;
`

export const ConfirmButton = styled(ActionButton)<{ $isPremium: boolean }>`
  flex: 2;
  ${premiumButtonStyles}
`

export const ThunderIcon = styled.img`
  width: 16px;
  height: 16px;
  filter: brightness(0) invert(1);
`

export const CreditsBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: ${COLORS.white};
`
